import React, { FC, useCallback, useMemo, useState } from 'react';
import { getEntityById } from '../../utils/DataAccessUtils';
import { updateChangeApplyStatus } from '../../thunks/acc_audits_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
	ACC_AUDIT_ACTIONABLE_STATUSES,
	ACC_AUDIT_KEY_DISPLAY_NAMES,
} from '../../utils/AssetCycleUtils';
import { Button, Dropdown, Menu, message, Spin } from 'antd';
import { DownOutlined, LoadingOutlined } from '@ant-design/icons';

const ACCAuditChangeActions: FC<any> = ({
	accAudit,
	updateChangeApplyStatus,
}): React.ReactElement => {
	const [updating, setUpdating] = useState(false);

	const onChangeApplyActionSelect = useCallback(
		(action) => () => {
			setUpdating(true);
			updateChangeApplyStatus(accAudit, action)
				.catch(message.error)
				.finally(() => setUpdating(false));
		},
		[accAudit, updateChangeApplyStatus]
	);

	const changeApplyActionMenu = useMemo(
		() => (
			<Menu selectedKeys={[accAudit.changeApplyStatus]}>
				{ACC_AUDIT_ACTIONABLE_STATUSES.map((action) => (
					<Menu.Item key={action} onClick={onChangeApplyActionSelect(action)}>
						{ACC_AUDIT_KEY_DISPLAY_NAMES[action]}
					</Menu.Item>
				))}
			</Menu>
		),
		[accAudit, onChangeApplyActionSelect]
	);

	return ACC_AUDIT_ACTIONABLE_STATUSES.includes(accAudit.changeApplyStatus) ? (
		<Dropdown overlay={changeApplyActionMenu}>
			<Button>
				<span>{ACC_AUDIT_KEY_DISPLAY_NAMES[accAudit.changeApplyStatus] || '--'}</span>
				<DownOutlined style={{ marginLeft: 8 }} />
				{updating ? (
					<Spin
						indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />}
						style={{ marginLeft: 8 }}
					/>
				) : null}
			</Button>
		</Dropdown>
	) : null;
};

const mapStateToProps = (state, ownProps) => ({
	cycleRun: getEntityById(ownProps.match.params.id, state.cycle_runs),
});

const mapDispatchToProps = (dispatch) => ({
	updateChangeApplyStatus: (entity, status) =>
		dispatch(updateChangeApplyStatus(ROLE_TYPES.BUYER)(entity, status)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ACCAuditChangeActions as any)
);
